import React from 'react'
import {useTranslation} from 'react-i18next'

import {useAuth} from "../../contexts/AuthContext"
import {useKeys as useItems} from '../../contexts/KeyContext'
import {useLockingSystems} from "../../contexts/LockingSystemContext"

import ItemList from '../../components/KeysInUse/List'
import PageList from '../common/List'
import {useIonViewWillEnter} from "@ionic/react";


const PageKeysInUseList: React.FC = () => {

    const { t } = useTranslation()
    const { getMe, userInfo: authUserInfo } = useAuth()

    useIonViewWillEnter(() => {
        getMe().then()
    })

    const
        itemType: string     = 'keysInUse',
        itemTypeName: string = t('keys.keyGroup.keys_in_use.title_list'),
        itemTypeUrl: string  = 'keys-in-use'

    const [showAddButton, setShowAddButton] = React.useState<boolean>(false)

    const { fetchItemsInUse } = useItems()

    const { selectedLockingSystemId, hasFeature: hasLockingSystemFeature } = useLockingSystems()

    React.useEffect(() => {
        if (selectedLockingSystemId) {
            const hasFeature = hasLockingSystemFeature('CAN_HAVE_PHONE_KEYS')

            if (hasFeature !== undefined) {
                if (hasFeature) {
                    if ((authUserInfo?.user?.counts?.keysAvailable || 0) < 1) {
                        setShowAddButton(false)
                    } else {
                        setShowAddButton(true)
                    }
                } else {
                    setShowAddButton(false)
                }
            }
        }
    }, [selectedLockingSystemId])

    return (
        <PageList
            ItemList={ItemList}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            showAddButton={showAddButton}
            fetchItems={fetchItemsInUse}
            useItems={useItems}
        />
    )
}

export default PageKeysInUseList